module.exports = __webpack_public_path__ + "img/reports.297dc03a.png";